import { TIMESPAN } from '@/enums/timespan';

const TIMESPAN_TO_PERIOD_KEY: Partial<Record<TIMESPAN, string>> = {
  [TIMESPAN.allTime]: 'ALL',
  [TIMESPAN.year]: 'YTD',
  [TIMESPAN.month]: '1M',
  [TIMESPAN.week]: '1W',
};

export { TIMESPAN_TO_PERIOD_KEY };
